import { render, staticRenderFns } from "./year.vue?vue&type=template&id=f6bd6bb6"
import script from "./year.vue?vue&type=script&lang=js"
export * from "./year.vue?vue&type=script&lang=js"
import style0 from "./year.vue?vue&type=style&index=0&id=f6bd6bb6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports